import type { Except } from "type-fest";
import type { SwishNumber } from "../swish-number";

type SwishPaymentRequest_EFlow = {
    /**
     * Payment reference of the payee, which is the merchant that receives the payment. This reference could be order id or similar.
     * Format: Allowed characters are a-z A-Z 0-9 -_.*+/ and length must be between 1 and 36 characters.
     * @type {string}
     */
    payeePaymentReference?: string;
    /**
     * URL that Swish will use to notify caller about the outcome of the Payment request. The URL has to use HTTPS
     * @type {string}
     */
    callbackUrl: string;
    /**
     * The Swish number of the one receiving the payment
     * @type {SwishNumber}
     */
    payeeAlias: SwishNumber;
    /**
     * The currency to use. The only currently supported value is SEK.
     * Format: SEK
     * @type {"SEK"}
     */
    currency: "SEK";
    /**
     * The amount of money to pay. The amount cannot be less than 0.01 SEK and not more than 999999999999.99 SEK. Valid value has to be all numbers or with 2-digit decimal separated by a period
     * Format: 100.00
     * @type {number}
     */
    amount: string;
    /**
     * Merchant supplied message about the payment/order. Max 50 chars. Allowed characters are the letters a-ö, A-Ö, the numbers 0-9 and the special characters :;.,?!()”
     * @type {string}
     */
    message?: string;
    /**
     * The registered cellphone number of the person that makes the payment. It can only contain numbers and has to be at least 8 and at most 15 numbers. It also needs to match the following format in order to be found in Swish: country code + cellphone number (without leading zero). E.g.: 46712345678
     * @type {SwishNumber}
     */
    payerAlias: SwishNumber;
};

type CreateSwishPaymentRequestParams_EFlow = Except<
    SwishPaymentRequest_EFlow,
    "currency"
>;
const createSwishPaymentRequest_EFlow = (
    params: CreateSwishPaymentRequestParams_EFlow,
): SwishPaymentRequest_EFlow => {
    return {
        ...params,
        currency: "SEK",
    };
};

export { createSwishPaymentRequest_EFlow };
export type {
    CreateSwishPaymentRequestParams_EFlow,
    SwishPaymentRequest_EFlow,
};
